export const ua = {
  // Menu
  menuTitle: "Меню",

  // Tabs
  tabAugment: "ЛС",
  tabSkill: "Скіли",
  tabEnchant: "Заточка речей",
  tabWeapon: "Зброя",
  tabEquipment: "Порівняти",
  tabSimulator: "Симулятор",

  // Augment Panel
  augmentConfig: "НАЛАШТУВАННЯ",
  desiredSkills: "Підійде скілів (з 178)",
  lifeStones: "В ІНВЕНТАРІ",
  stoneLife: "Life",
  stoneMid: "Mid",
  stoneTop: "Top",
  stoneUltimate: "Ult",
  successProbability: "Пощастить з шансом",
  probabilityOfSuccess: "Шанс зловити хоча б 1 з {n}:",
  probabilityOfSpecificSuccess: "Шанс отримати один скілл:",
  withCurrentStones: "з поточними каменями",
  withTotalAugmentations: "з",
  totalAugmentation: "спробою",
  totalAugmentationsPlural: "спробами",
  lifeStonePrice: "Ціна Life Stone (в адені)",
  topGradePrice: "Ціна Top-Grade Life Stone (в адені)",
  priceSettings: "Ціни",

  // Augment Analysis
  analysis: "АНАЛІЗ",
  singleAugmentSuccess: "Шанс успіху за 1 спробу",
  expectedAttemptsNeeded: "У середньому спроб",
  expectedCostAdena: "Середня вартість (адена)",
  skillChance1: "1% шанс на скіл",
  skillChance6: "6% шанс на скіл",
  skillChance25: "25% шанс на скіл",
  skillChance100: "100% шанс на скіл",
  stoneLife: "Life",
  stoneMid: "Mid",
  stoneTop: "Top",
  stoneUltimate: "Ultimate",

  // Skill Enchant Panel
  skillEnchantMastery: "Skill Enchant Mastery",
  masteryNone: "Немає",
  targetEnchantLevel: "ЦІЛЬ",
  alreadyEnchanted: "Вже заточений",
  currentLevel: "Поточний рівень",
  safeLevels: "Безпечні:",
  enchantChances: "ШАНСИ",
  enchantChancesHint: "📖 = потрібна книга · Зелений = безпечно",
  expectedCostSummary: "Очікувані витрати +{currentLevel} → +{targetLevel}",
  booksGuaranteed: "Книг знадобиться (мінімум)",
  expectedAttempts: "У середньому спроб",
  expectedBooks: "У середньому книг",
  expectedBooksCost: "Загальна вартість книг",
  masterySavesPerSkill: "Економія на скіл",
  masteryOneTimeCost: "Вартість майстерності (разово)",
  masteryBreakEvenVsNone: "vs Немає",
  masteryBreakEvenVsPrev: "vs",
  afterSkills: "{n} скілів",
  paysOffNow: "1 скіл",
  books: "книг",
  enchantBookPrice: "Ціна книги гігантів (в адені)",
  ancientAdenaPrice: "Ціна Ancient Adena (в адені)",

  // Enchant Panel
  configuration: "НАЛАШТУВАННЯ",
  enchantChancesTitle: "ШАНСИ",
  expectedAttemptsTitle: "У СЕРЕДНЬОМУ",
  regularScrolls: "Звичайні точки",
  itemsNeeded: "речей знадобиться",
  blessedScrolls: "Блеси",
  prices: "ЦІНИ",
  itemPrice: "Ціна речі",
  regularScrollPrice: "Ціна точки",
  blessedScrollPrice: "Ціна блесу",
  expectedCostComparison: "ПОРІВНЯННЯ ВАРТОСТІ",
  regularCost: "Звичайні (точки + злам речей)",
  blessedCost: "Блеси",
  recommendation: "Рекомендація",
  recBlessed: "Блеси",
  recRegular: "Звичайні",
  viewCostPerLevel: "За рівнями",
  hide: "Приховати",
  levelCol: "Рів.",
  scrollsCol: "Кількість",
  regularCol: "Звичайні",
  blessedCol: "Блеси",

  // Simulator Panel
  sim_instruction: "Оберіть камінь і натисніть Аугментувати",
  sim_success: "Аугментація успішна!",
  sim_loading: "Завантаження звуків...",
  sim_augmenting: "Аугментація...",
  sim_augment_btn: "АУГМЕНТУВАТИ",
  sim_used: "Витрачено",
  sim_skill_rate: "Скіл %",
  sim_best: "Найкраща серія",
  sim_worst: "Найгірша серія",
  sim_history: "ОСТАННІ АУГМЕНТАЦІЇ",
  sim_mute: "Вимкнути звук",
  sim_unmute: "Увімкнути звук",

  // Equipment Panel
  equip_weapon: "Зброя",
  equip_armor: "Броня",
  equip_jewelry: "Біжа",
  weaponType: "ТИП ЗБРОЇ",
  armorType: "ТИП БРОНІ",
  myWeapon: "МОЯ ЗБРОЯ",
  myArmor: "МІЙ КОМПЛЕКТ БРОНІ",
  myJewelrySet: "МІЙ КОМПЛЕКТ БІЖІ",
  myJewelryPiece: "МОЯ БІЖА",
  compareTo: "ПОРІВНЯТИ З",
  crossoverAt: "Наздожене на",
  diffAt: "Різн. @+{n}",
  enchantLevel: "Заточка",
  jewelry_sets: "Комплекти",
  jewelry_individual: "Поштучно",
  jewelry_necklace: "Намисто",
  jewelry_earring: "Сережка",
  jewelry_ring: "Кільце",
  jewelryPieceType: "ТИП ПРЕДМЕТА",
  armor_heavy: "Важка",
  armor_light: "Легка",
  armor_robe: "Роба",
  weapon_sword: "Меч",
  weapon_blunt: "Булава",
  weapon_dagger: "Кинджал",
  weapon_pike: "Спис",
  weapon_fist: "Кулаки",
  weapon_dual: "Парні",
  weapon_bow: "Лук",
  weapon_mage: "Магіч.",
  hideBreakdown: "Сховати таблицю",
  viewAllLevels: "Показати повну таблицю",

  // Wiki Panel
  tabWiki: "База знань",
  wikiSection_events: "Івенти",
  wikiSection_marks: "Марки",

  // Events Schedule
  eventsServerTime: "Час сервера",
  eventsLocalTime: "Місцевий час",
  eventsYourTime: "Мiсцеве",
  eventsServerTimeHeader: "Сервер",
  eventsEventName: "Івент",
  eventsRecentPast: "Минулі",
  eventsNow: "ЗАРАЗ",
  eventsToday: "Сьогодні",
  eventsTomorrow: "Завтра",
  eventsNote: "Час вказано за сервером (GMT+3) та у вашому часовому поясі. Розклад оновлюється щохвилини.",
  wikiMarksIntro: "Марки дають випадкові стати на +5, +7, +9. Стати 1 тіру подвоюються на +6 та знову на +8. Стати 2 тіру подвоюються на +8. На +10 фіксований стат.",
  wikiStatName: "Стат",
  wikiMarkNote: "Один випадковий стат на тір. 1 тір також подвоюється на +8.",
  wikiFixedStat: "фікс.",
  wikiPlain: "Mark",
  wikiEnchantBonuses: "Бонуси заточки",
  wikiAllStats: "всі стати",
  wikiRandomStat: "один випад.",
  wikiMark_avadon: "Mark of Avadon",
  wikiMark_speed: "Mark of Speed",
  wikiMark_hunter: "Mark of Hunter",
  wikiMark_defender: "Mark of Defender",
  wikiMark_divine: "Mark of Divine",
  wikiMark_doom: "Mark of Doom",
  wikiMark_immunity: "Mark of Immunity",
  wikiMark_power: "Mark of Power",
  wikiMark_blood: "Mark of Blood",

  // Keyboard
  done: "Готово"
};
